import React, { useEffect, useState,useCallback } from "react";
import Container from "react-bootstrap/Container";
import { Select, Spin, Tabs, message } from "antd"; // Import message for notifications
import { TbCurrencyDollar } from "react-icons/tb";
import { FaStethoscope } from "react-icons/fa6";
import { apiCall } from "../api/apiRoutes.ts";
import { NetworkInfo } from "../constants/network.ts";
import showMessageQueue from '../utils/messageUtils.js';
const { TabPane } = Tabs;

const DashboardPage: React.FC = () => {
  const [dashboards, setDashboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [clientId,setClientId]=useState(0);
  const [clients, setClients] = useState([]);  
  // Get currentClientId from localStorage
  const storedUser:any = localStorage.getItem('usmonUser');
  const parsedUser = storedUser ? JSON.parse(storedUser) : {};
  const currentClientId = Object.keys(parsedUser?.user?.current_client || {})[0];
  const [selectedClient, setSelectedClient] = useState<string>('');
  
  
  const [messages, contextHolder] = message.useMessage();
  const isAdminRole = (parsedUser?.isUserAdmin==='usmon-admin' )? true : false; 
    // setting client id from local storage
    useEffect(() => {
      const getClientIdFromLocalStorage = () => {
        try {
          let storedUser = localStorage.getItem("usmonUser");
          let parsedUser = storedUser ? JSON.parse(storedUser) : {};
          const currentClientId = Object.keys(parsedUser?.user?.current_client || {})[0]; // Get the first key from the object
          const newClientId = Number(currentClientId);

          if (!isNaN(newClientId) && newClientId !== clientId) {
            setClientId(newClientId);  // Update state if it's a valid number and different
            setSelectedClient(currentClientId); // Update selectedClient as well
          }
        } catch (error) {
          console.error("Error parsing localStorage or extracting clientId:", error);
        }
      };

      getClientIdFromLocalStorage();     // initial fetch of clientId
      // storage event listener
      const handleStorageChange = () => {
        getClientIdFromLocalStorage();  // re-fetch clientId and selectedClient on localStorage changes
      };
      window.addEventListener('storage', handleStorageChange);
      // cleanup the event listener
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, [clientId]);


   const getDashboards = useCallback(async () => {
    try {
      let storedUser = localStorage.getItem("usmonUser");
      let parsedUser = storedUser ? JSON.parse(storedUser) : {};
      const currentClientId = Object.keys(parsedUser?.user?.current_client)[0]; // Get the first key from the object
      const cId = Number(currentClientId);

      let data = { clientId: cId, userId: parsedUser?.user?.email };
      setIsLoading(true);
      const response = await apiCall(data,`${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.quicksight}${NetworkInfo.endpoints.embedUrl}`, "get",false,false,false);

      if (response?.data) {
        setDashboardData(response.data);
      } else {
        showMessageQueue(messages,"error","Failed to fetch dashboard data.")
        console.error("API call returned empty data:", response); // Log for debugging
      }
    } catch (error) {
      showMessageQueue(messages,"error",error?.response?.data?.message || "Error fetching dashboard data.")
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  },[messages]);

  // assigned data api call and pending license request api call
  useEffect(() => {
    const fetchPendingData = async () => {
      if (clientId && !isAdminRole) {
        await getDashboards();
      }
    };
  
    fetchPendingData();
  }, [clientId,getDashboards,isAdminRole]);


  const fetchClients = useCallback(() => {
    apiCall({}, `${NetworkInfo.endpoints.webclient}${NetworkInfo.endpoints.webclients}`, "get", true, false, false).then((response: any) => {
      if (response?.success) {
        setClients(response?.data);        
        if (currentClientId && response?.data?.length) {
          const foundClient = response.data.find((c: any) => String(c.client_id) === String(currentClientId));
          if (foundClient) {
            setSelectedClient(foundClient.client_id);
          }
        }
      } else {
        showMessageQueue(messages, "error", response?.message)
      }
    });
  }, [messages,currentClientId]);

  useEffect(() => {
    if (isAdminRole) {
      fetchClients();     
    }
  }, [isAdminRole, fetchClients]);
 

   // Fetch embed URLs for selected client (admin)
  const fetchClientEmbedUrls = useCallback(async (selectedClient: string | number) => {
    if (!selectedClient) return;
    setIsLoading(true);
    try {
      // Direct API call for admin embed URLs
      const response = await apiCall({}, `${NetworkInfo.endpoints.insights}${NetworkInfo.endpoints.quicksight}${NetworkInfo.endpoints.clientembedUrl}?clientId=${selectedClient}`, "get", false, false, false);      
      if (response?.data) {
        setDashboardData(response.data);
      } else {
        showMessageQueue(messages, "error", response?.data?.message || "Failed to fetch embed URLs.");
      }
    } catch (error) {
      showMessageQueue(messages, "error", error?.response?.data?.message || "Error fetching embed URLs.");
    } finally {
      setIsLoading(false);
    }
  }, [messages]);

   useEffect(() => {
    if (isAdminRole && selectedClient) {
      fetchClientEmbedUrls(selectedClient);
    }
  }, [selectedClient, fetchClientEmbedUrls, isAdminRole]);

  return (
    <div className="main-wrapper" >
    {isAdminRole && (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '16px 32px 0 0', background: 'transparent', gap: 12 }}>
        <label className="label-text" style={{ fontWeight: 500, marginBottom: 0, textAlign: 'right' }}>SELECT CLIENT : </label>
        <div className="input-wrap category-filter" style={{ width: 220 }}>
          <Select
            placeholder="Select client"
            value={selectedClient || '*'}
            onChange={(value: any) => {             
              setSelectedClient(value);
              // fetchClientEmbedUrls(value);
            }}
            style={{ width: '100%', minHeight: 36, fontSize: 15 }}
            showSearch
            filterOption={(input: string, option: any) =>
              (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
            }
            size="middle"
          >
            <Select.Option key="all-clients" value="*">All</Select.Option>
            {clients.map((option: any) => (
              <Select.Option
                key={`${option.client_id}-${option.client_mother_company}-${option.region_short_name}`}
                value={option.client_id}
              >
                {option.client_mother_company}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    )}

      {contextHolder}
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spin size="large" />
        </div>
      ) : (
        <Container fluid>
          <Tabs
            className="dashboard-tab mt-4"
            defaultActiveKey="1"
            style={{ width: "100%" }}
            tabPosition="top"
            type="card"
          >
            {dashboards.map((dashboard: any, index: number) => {
              const icon =
                dashboard?.serviceId === 10001 ? (
                  <FaStethoscope />
                ) : (
                  <TbCurrencyDollar />
                );

              return (
                <TabPane
                  tab={
                    <span>
                      {icon}{" "}
                      <span style={{ marginLeft: 8 }}>
                        {dashboard?.serviceId === 10001
                          ? "Basic License Dashboard"
                          : dashboard?.serviceId === 10002
                          ? "Plus License Dashboard"
                          : ' '}
                      </span>
                    </span>
                  }
                  key={String(index + 1)}
                >
                  <iframe
                    src={dashboard?.url}
                    width="100%"
                    height="600px"
                    title={
                      dashboard?.serviceId === 10001
                        ? "Basic License Dashboard"
                        : dashboard?.serviceId === 10002
                        ? "Plus License Dashboard"
                        : dashboard.name
                    }
                    allow="fullscreen"
                    style={{
                      border: "none",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    }}
                    allowFullScreen
                    onError={(e) => {
                      console.error("Iframe failed to load:", dashboard.url, e);
                      showMessageQueue(messages,"error",`Iframe failed to load: ${dashboard.name || 'Dashboard'}`)
                    }}
                  />
                </TabPane>
              );
            })}
          </Tabs>
        </Container>
      )}
    </div>
  );
};

export default DashboardPage;
